"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fiats = [
    {
        country: "AE",
        currency: "AED",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 1.47,
        feeRate: 0.0499,
        payMin: 3.0,
        payMax: 20365.0,
        countryName: "United Arab Emirates",
    },
    {
        country: "AE",
        currency: "AED",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 1.47,
        feeRate: 0.0499,
        payMin: 3.0,
        payMax: 20000.0,
        countryName: "United Arab Emirates",
    },
    {
        country: "AE",
        currency: "AED",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 1.46,
        feeRate: 0.0499,
        payMin: 3.0,
        payMax: 18362.0,
        countryName: "United Arab Emirates",
    },
    {
        country: "AU",
        currency: "AUD",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 0.59,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 8000.0,
        countryName: "Australia",
    },
    {
        country: "AU",
        currency: "AUD",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 0.59,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 8000.0,
        countryName: "Australia",
    },
    {
        country: "AU",
        currency: "AUD",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 0.6,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 7510.76,
        countryName: "Australia",
    },
    {
        country: "BG",
        currency: "BGN",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 0.7,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 9000.0,
        countryName: "Bulgaria",
    },
    {
        country: "BR",
        currency: "BRL",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 1.92,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 24992.0,
        countryName: "Brazil",
    },
    {
        country: "BR",
        currency: "BRL",
        payWayCode: "30001",
        payWayName: "Pix Pay",
        fixedFee: 2.0,
        feeRate: 0.0395,
        payMin: 4.0,
        payMax: 50000.0,
        countryName: "Brazil",
    },
    {
        country: "CA",
        currency: "CAD",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 0.53,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 7000.0,
        countryName: "Canada",
    },
    {
        country: "CA",
        currency: "CAD",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 0.54,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 7000.0,
        countryName: "Canada",
    },
    {
        country: "CA",
        currency: "CAD",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 0.53,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 6727.08,
        countryName: "Canada",
    },
    {
        country: "CH",
        currency: "CHF",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 0.35,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 5000.0,
        countryName: "Switzerland",
    },
    {
        country: "CO",
        currency: "COP",
        payWayCode: "12000",
        payWayName: "PSE",
        fixedFee: 0.0,
        feeRate: 0.035,
        payMin: 2000.0,
        payMax: 3000000.0,
        countryName: "Colombia",
    },
    {
        country: "DE",
        currency: "EUR",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 0.36,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 5000.0,
        countryName: "Germany",
    },
    {
        country: "DE",
        currency: "EUR",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 0.376,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 5000.0,
        countryName: "Germany",
    },
    {
        country: "DE",
        currency: "EUR",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 0.37,
        feeRate: 0.0499,
        payMin: 0.5,
        payMax: 4648.33,
        countryName: "Germany",
    },
    {
        country: "DK",
        currency: "DKK",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 2.68,
        feeRate: 0.0499,
        payMin: 6.0,
        payMax: 34444.0,
        countryName: "Denmark",
    },
    {
        country: "GB",
        currency: "GBP",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 0.31,
        feeRate: 0.0499,
        payMin: 0.5,
        payMax: 5000.0,
        countryName: "United Kingdom",
    },
    {
        country: "HK",
        currency: "HKD",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 3.13,
        feeRate: 0.0499,
        payMin: 7.0,
        payMax: 40000.0,
        countryName: "Hong Kong",
    },
    {
        country: "HK",
        currency: "HKD",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 3.12,
        feeRate: 0.0499,
        payMin: 5.0,
        payMax: 40000.0,
        countryName: "Hong Kong",
    },
    {
        country: "HK",
        currency: "HKD",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 3.13,
        feeRate: 0.0499,
        payMin: 5.0,
        payMax: 39248.0,
        countryName: "Hong Kong",
    },
    {
        country: "ID",
        currency: "IDR",
        payWayCode: "10003",
        payWayName: "Virtual Account",
        fixedFee: 6500.0,
        feeRate: 0.025,
        payMin: 10000.0,
        payMax: 100000000.0,
        countryName: "Indonesia",
    },
    {
        country: "ID",
        currency: "IDR",
        payWayCode: "10004",
        payWayName: "QRIS",
        fixedFee: 0.0,
        feeRate: 0.035,
        payMin: 10000.0,
        payMax: 10000000.0,
        countryName: "Indonesia",
    },
    {
        country: "ID",
        currency: "IDR",
        payWayCode: "10005",
        payWayName: "DANA",
        fixedFee: 1000.0,
        feeRate: 0.045,
        payMin: 10000.0,
        payMax: 20000000.0,
        countryName: "Indonesia",
    },
    {
        country: "ID",
        currency: "IDR",
        payWayCode: "10006",
        payWayName: "OVO",
        fixedFee: 1000.0,
        feeRate: 0.045,
        payMin: 10000.0,
        payMax: 10000000.0,
        countryName: "Indonesia",
    },
    {
        country: "IL",
        currency: "ILS",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 1.45,
        feeRate: 0.0499,
        payMin: 3.0,
        payMax: 20000.0,
        countryName: "Israel",
    },
    {
        country: "IN",
        currency: "INR",
        payWayCode: "90001",
        payWayName: "UPI",
        fixedFee: 0.0,
        feeRate: 0.0175,
        payMin: 1250.0,
        payMax: 200000.0,
        countryName: "India",
    },
    {
        country: "JP",
        currency: "JPY",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 56.07,
        feeRate: 0.0499,
        payMin: 100.0,
        payMax: 750837.0,
        countryName: "Japan",
    },
    {
        country: "JP",
        currency: "JPY",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 53.42,
        feeRate: 0.0499,
        payMin: 100.0,
        payMax: 700000.0,
        countryName: "Japan",
    },
    {
        country: "JP",
        currency: "JPY",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 53.45,
        feeRate: 0.0499,
        payMin: 100.0,
        payMax: 668192.0,
        countryName: "Japan",
    },
    {
        country: "KR",
        currency: "KRW",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 512.0,
        feeRate: 0.0499,
        payMin: 1300.0,
        payMax: 7000000.0,
        countryName: "Korea",
    },
    {
        country: "KR",
        currency: "KRW",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 505.8,
        feeRate: 0.0499,
        payMin: 1000.0,
        payMax: 7000000.0,
        countryName: "Korea",
    },
    {
        country: "KR",
        currency: "KRW",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 531.0,
        feeRate: 0.0499,
        payMin: 1000.0,
        payMax: 6638687.0,
        countryName: "Korea",
    },
    {
        country: "KZ",
        currency: "KZT",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 178.0,
        feeRate: 0.0499,
        payMin: 400.0,
        payMax: 2535759.0,
        countryName: "Kazakhstan",
    },
    {
        country: "MD",
        currency: "MDL",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 7.0,
        feeRate: 0.0499,
        payMin: 17.0,
        payMax: 90000.0,
        countryName: "Republic of Moldova",
    },
    {
        country: "MK",
        currency: "MKD",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 22.0,
        feeRate: 0.0499,
        payMin: 55.0,
        payMax: 280000.0,
        countryName: "North Macedonia",
    },
    {
        country: "MX",
        currency: "MXN",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 6.76,
        feeRate: 0.0499,
        payMin: 16.0,
        payMax: 90000.0,
        countryName: "Mexico",
    },
    {
        country: "MX",
        currency: "MXN",
        payWayCode: "601",
        payWayName: "SPEI",
        fixedFee: 8.0,
        feeRate: 0.03,
        payMin: 8.0,
        payMax: 190000.0,
        countryName: "Mexico",
    },
    {
        country: "MY",
        currency: "MYR",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 1.82,
        feeRate: 0.0499,
        payMin: 4.0,
        payMax: 23764.0,
        countryName: "Malaysia",
    },
    {
        country: "MY",
        currency: "MYR",
        payWayCode: "13000",
        payWayName: "Bank Transfer",
        fixedFee: 0.0,
        feeRate: 0.045,
        payMin: 40.0,
        payMax: 50000.0,
        countryName: "Malaysia",
    },
    {
        country: "NG",
        currency: "NGN",
        payWayCode: "18000",
        payWayName: "Bank Transfer",
        fixedFee: 760.0,
        feeRate: 0.025,
        payMin: 5000.0,
        payMax: 4000000.0,
        countryName: "Nigeria",
    },
    {
        country: "NO",
        currency: "NOK",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 4.0,
        feeRate: 0.0499,
        payMin: 10.0,
        payMax: 51000.0,
        countryName: "Norway",
    },
    {
        country: "NZ",
        currency: "NZD",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 0.64,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 9000.0,
        countryName: "New Zealand",
    },
    {
        country: "NZ",
        currency: "NZD",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 0.63,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 8000.0,
        countryName: "New Zealand",
    },
    {
        country: "NZ",
        currency: "NZD",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 0.64,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 8072.73,
        countryName: "New Zealand",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41001",
        payWayName: "Insta Pay",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 50000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41002",
        payWayName: "Maya Pay",
        fixedFee: 0.0,
        feeRate: 0.045,
        payMin: 1.0,
        payMax: 50000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41003",
        payWayName: "Security Online",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41004",
        payWayName: "BDO",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41005",
        payWayName: "PsBank",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 10.0,
        payMax: 25000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41006",
        payWayName: "RCBC",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41007",
        payWayName: "PbCom",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41008",
        payWayName: "Union Bank",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41009",
        payWayName: "Maya Pay",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 20.0,
        payMax: 100000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41010",
        payWayName: "Ucpb Online",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41011",
        payWayName: "Metro Bank",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41012",
        payWayName: "Coins Ph",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 5.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41013",
        payWayName: "Pesonet",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 50000.0,
        payMax: 10000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41015",
        payWayName: "MayBank2u",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41016",
        payWayName: "China Bank",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41017",
        payWayName: "Robinsons Online",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 10.0,
        payMax: 1000000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41018",
        payWayName: "LandBank ATM",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 200000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41019",
        payWayName: "BPI",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 1.0,
        payMax: 49900.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41020",
        payWayName: "Grab Pay",
        fixedFee: 0.0,
        feeRate: 0.045,
        payMin: 1.0,
        payMax: 100000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "41021",
        payWayName: "Bank of Commerce",
        fixedFee: 30.0,
        feeRate: 0.025,
        payMin: 10.0,
        payMax: 100000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "80040",
        payWayName: "BPI",
        fixedFee: 22.5,
        feeRate: 0.025,
        payMin: 900.0,
        payMax: 50000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "80041",
        payWayName: "UNION_BANK",
        fixedFee: 22.5,
        feeRate: 0.025,
        payMin: 900.0,
        payMax: 50000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "80059",
        payWayName: "GCASH",
        fixedFee: 22.5,
        feeRate: 0.035,
        payMin: 900.0,
        payMax: 100000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "80070",
        payWayName: "RCBC",
        fixedFee: 22.5,
        feeRate: 0.025,
        payMin: 900.0,
        payMax: 50000.0,
        countryName: "Philippines",
    },
    {
        country: "PH",
        currency: "PHP",
        payWayCode: "90007",
        payWayName: "QRPH",
        fixedFee: 0.0,
        feeRate: 0.045,
        payMin: 900.0,
        payMax: 50000.0,
        countryName: "Philippines",
    },
    {
        country: "PL",
        currency: "PLN",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 1.6,
        feeRate: 0.0499,
        payMin: 4.0,
        payMax: 20000.0,
        countryName: "Poland",
    },
    {
        country: "RO",
        currency: "RON",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 1.77,
        feeRate: 0.0499,
        payMin: 4.0,
        payMax: 23153.0,
        countryName: "Romania",
    },
    {
        country: "SE",
        currency: "SEK",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 4.0,
        feeRate: 0.0499,
        payMin: 10.0,
        payMax: 52000.0,
        countryName: "Sweden",
    },
    {
        country: "SG",
        currency: "SGD",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 0.53,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 7000.0,
        countryName: "Singapore",
    },
    {
        country: "SG",
        currency: "SGD",
        payWayCode: "40001",
        payWayName: "PAY NOW",
        fixedFee: 0.0,
        feeRate: 0.03,
        payMin: 1.0,
        payMax: 2000.0,
        countryName: "Singapore",
    },
    {
        country: "SG",
        currency: "SGD",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 0.54,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 7000.0,
        countryName: "Singapore",
    },
    {
        country: "SG",
        currency: "SGD",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 0.53,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 6663.7,
        countryName: "Singapore",
    },
    {
        country: "TH",
        currency: "THB",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 13.72,
        feeRate: 0.0499,
        payMin: 30.0,
        payMax: 200000.0,
        countryName: "Thailand",
    },
    {
        country: "TH",
        currency: "THB",
        payWayCode: "40003",
        payWayName: "THAI_QR",
        fixedFee: 0.0,
        feeRate: 0.035,
        payMin: 100.0,
        payMax: 200000.0,
        countryName: "Thailand",
    },
    {
        country: "TR",
        currency: "TRY",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 10.73,
        feeRate: 0.0499,
        payMin: 26.0,
        payMax: 144081.0,
        countryName: "Turkey",
    },
    {
        country: "TR",
        currency: "TRY",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 7.49,
        feeRate: 0.0499,
        payMin: 20.0,
        payMax: 100000.0,
        countryName: "Turkey",
    },
    {
        country: "TR",
        currency: "TRY",
        payWayCode: "51001",
        payWayName: "Vakif Bank",
        fixedFee: 0.0,
        feeRate: 0.02,
        payMin: 500.0,
        payMax: 50000.0,
        countryName: "Turkey",
    },
    {
        country: "TR",
        currency: "TRY",
        payWayCode: "51002",
        payWayName: "Ziraat Bank",
        fixedFee: 0.0,
        feeRate: 0.02,
        payMin: 500.0,
        payMax: 50000.0,
        countryName: "Turkey",
    },
    {
        country: "TR",
        currency: "TRY",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 7.72,
        feeRate: 0.0499,
        payMin: 20.0,
        payMax: 96561.0,
        countryName: "Turkey",
    },
    {
        country: "TW",
        currency: "TWD",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 12.5,
        feeRate: 0.0499,
        payMin: 31.0,
        payMax: 156257.0,
        countryName: "Taiwan, Province of China",
    },
    {
        country: "TW",
        currency: "TWD",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 12.29,
        feeRate: 0.0499,
        payMin: 20.0,
        payMax: 160000.0,
        countryName: "Taiwan, Province of China",
    },
    {
        country: "TW",
        currency: "TWD",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 12.21,
        feeRate: 0.0499,
        payMin: 20.0,
        payMax: 152678.9,
        countryName: "Taiwan, Province of China",
    },
    {
        country: "US",
        currency: "USD",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 0.4,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 5000.0,
        countryName: "United States of America",
    },
    {
        country: "US",
        currency: "USD",
        payWayCode: "501",
        payWayName: "Apple Pay",
        fixedFee: 0.4,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 5000.0,
        countryName: "United States of America",
    },
    {
        country: "US",
        currency: "USD",
        payWayCode: "701",
        payWayName: "Google Pay",
        fixedFee: 0.4,
        feeRate: 0.0499,
        payMin: 1.0,
        payMax: 5000.0,
        countryName: "United States of America",
    },
    {
        country: "VN",
        currency: "VND",
        payWayCode: "10001",
        payWayName: "Credit Card",
        fixedFee: 9462.0,
        feeRate: 0.0499,
        payMin: 20000.0,
        payMax: 118275000.0,
        countryName: "Vietnam",
    },
    {
        country: "VN",
        currency: "VND",
        payWayCode: "210",
        payWayName: "Bank Transfer",
        fixedFee: 0.0,
        feeRate: 0.045,
        payMin: 50000.0,
        payMax: 50000000.0,
        countryName: "Vietnam",
    },
];
exports.default = fiats;
//# sourceMappingURL=fiats.js.map